import { router } from '@/shared/router';
import { miniApp, retrieveLaunchParams, swipeBehavior, viewport } from '@telegram-apps/sdk-react';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

export const App = () => {
  // const isDark = useSignal(themeParams.isDark);
  const lp = retrieveLaunchParams();

  // useEffect(() => {
  //   const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  //   console.log(mediaQuery);
  //   console.log(isDark);

  //   // Initial check
  //   if (mediaQuery.matches) {
  //     document.body.classList.add('dark');
  //   } else if (isDark) {
  //     document.body.classList.add('dark');
  //   } else {
  //     document.body.classList.remove('dark');
  //   }

  //   // Listen to changes
  //   mediaQuery.addEventListener('change', (e) => {
  //     if (e.matches) {
  //       document.body.classList.add('dark');
  //       console.log('Switched to dark mode');
  //     } else {
  //       document.body.classList.remove('dark');
  //       console.log('Switched to light mode');
  //     }
  //   });
  // }, []);

  useEffect(() => {
    miniApp.setBackgroundColor('#efeff4');
    miniApp.setBottomBarColor('#efeff4');
    miniApp.setHeaderColor('#efeff4');
  }, []);

  useEffect(() => {
    swipeBehavior.mount();
    swipeBehavior.disableVertical();
    if (!['tdesktop', 'macos'].includes(lp.tgWebAppPlatform)) viewport.requestFullscreen();
  }, [lp.tgWebAppPlatform]);

  return <RouterProvider router={router} />;
};
